import {
  LEGEND_MAX_SCALE,
  LEGEND_MIN_SCALE,
  LEGEND_REFERENCE_PAGE_SIDE,
} from "../LegendBox";
import type { ComputeNotePageScale } from "./types";

export const computeNotePageScale: ComputeNotePageScale = ({
  pdfPageWidth,
  pdfPageHeight,
}) => {
  const longerPageSide = Math.max(pdfPageWidth, pdfPageHeight);
  return Math.min(
    LEGEND_MAX_SCALE,
    Math.max(LEGEND_MIN_SCALE, longerPageSide / LEGEND_REFERENCE_PAGE_SIDE),
  );
};
